import Auth from "../singleton/auth";

export default {

    getDefaultInstance: Auth.getDefaultInstance.bind(Auth),

    isAuthorized: Auth.isAuthorized.bind(Auth),

    getInstances: Auth.getInstances.bind(Auth),

    autologin: Auth.autologin.bind(Auth),

    register: Auth.register.bind(Auth),

    logout: Auth.logout.bind(Auth),

    login: Auth.login.bind(Auth),

    use: Auth.use.bind(Auth)

}